import { isObject } from './isObject';
import { IOrderDiscount } from '@domain/orders/types';

export const isOfferAPromo = (offer: IOrderDiscount): boolean =>
  isObject(offer) && !('spotOnRewardId' in offer);
